import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import OwnerDashboard from "@/components/OwnerDashboard";
import GuardDashboard from "@/components/GuardDashboard";
import VisitorPass from "@/components/VisitorPass";
import AdminDashboard from "@/components/AdminDashboard";
import SuperAdminDashboard from "@/components/SuperAdminDashboard";
import SocietyRegistration from "@/components/SocietyRegistration";
import VisitorCheckIn from "@/components/VisitorCheckIn";
import VisitorExit from "@/components/VisitorExit";
import LandingPage from "@/components/LandingPage";
import AuthPage from "@/components/AuthPage";

import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// Use relative /api path to avoid cross-origin issues with custom domains
// Both preview (society-slots.preview.emergentagent.com) and production (parkshare.in)
// proxy /api to the backend on the same domain
export const API = '/api';

// Send httpOnly cookies with all API requests
axios.defaults.withCredentials = true;

// Auth token management for cross-domain requests (v2)
let authToken = null;
export const setAuthToken = (token) => { authToken = token; };
export const clearAuthToken = () => { authToken = null; };

// Attach token as Authorization header for cross-domain requests
axios.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth/:role" element={<AuthPage />} />
          <Route path="/owner" element={<OwnerDashboard />} />
          <Route path="/guard" element={<GuardDashboard />} />
          <Route path="/visitor/:booking_id" element={<VisitorPass />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/superadmin" element={<SuperAdminDashboard />} />
          <Route path="/register/:society_code" element={<SocietyRegistration />} />
          <Route path="/visitor-checkin/:society_code" element={<VisitorCheckIn />} />
          <Route path="/visitor-exit/:society_code" element={<VisitorExit />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
